export const IsAuthenticated = '__IsAuthenticated__';
export const UserName = '__UserName__';
export const IdToken = '__IdToken__';
export const OrderItemData = '__OrderItemData__';
export const init = '__Init__';
export const loading = '__Loading__';
export const loaded = '__Loaded__';
export const error = '__Error__';

export enum ProgressStatus {
    Init = "__Init__",
    Loading = '__Loading__',
    Loaded = '__Loaded__',
    Error = '__Error__'
}

export const MaxOrderItems = 10;
export const MaxOrderItemDescription = 90;